<template lang="pug">
  .journals-list
    v-scroll-y-transition(leave-absolute)
      v-skeleton-loader(
        v-if="loading"
        type="list-item-two-line@3"
      )
    v-list(nav)
      v-list-item.grey.lighten-5.sdo-radius.pa-3(
        v-for="(journal, idx) in journals"
        :key="idx"
      )
        v-list-item-action
          v-chip.text-caption(
            :color="`${TASK_STATUS_COLORS[journal.status]} lighten-5`"
          )
            div(
              :class="`${TASK_STATUS_COLORS[journal.status]}--text`"
            ) {{ TASK_STATUS_NAMES[journal.status] }}

        v-list-item-content
          div {{ journal.journal_answer.updated_at | dp('dd MMMM HH:mm') }}
          .text-caption(
            v-if="journal.error_task_unit_count || isConsult"
          )
            span Неправильных ответов: {{ journal.error_task_unit_count }}

          template(v-if="!isConsult")
            template(v-if="journal.comment && task.type === 1")
              span.text-caption.black--text Коментарий:
              .text-caption.black--text.mt-1 - {{ journal.comment }}

            template(v-if="journal.error_comments")
              span.text-caption.black--text.
                На основании анализа выполненного задания рекомендуется обратить внимание на:
              .text-caption.black--text.mt-1(
                v-for="message in journal.error_comments"
              ) - {{ message }}
          div(v-if="journal.mark && task.type === 1")
            v-chip.px-6.mt-4(
              color="primary" outlined
            ) Оценка:
              strong.ml-2 {{ journal.mark }}
        v-list-item-action.ml-0
          v-btn(
            color="secondary lighten-2"
            outlined
            text
            @click="handleDetailTask(journal)"
          ) Подробнее
</template>

<script>
import { format } from 'date-fns';

import {
  TASK_STATUS_NAMES,
  TASK_STATUS_COLORS,
} from '@/utils/constants';

export default {
  props: {
    task: { type: Object, required: true },
    userId: { type: [String, Number], default: null },
    isConsult: { type: Boolean, default: false },
  },
  data: () => ({
    TASK_STATUS_NAMES,
    TASK_STATUS_COLORS,

    journals: [],
    loading: true,
  }),
  created() {
    this.getJournal();
  },
  methods: {
    handleDetailTask(journal) {
      if (this.isConsult) this.toCheckTask(journal.journal_answer.id, journal.group_id);
      else this.showDetailWrongAnsewer(journal.error_task_units);
    },
    toCheckTask(journalid, groupId) {
      const routeData = this.$router.resolve({
        name: 'TaskCheck',
        params: { id: this.task.id },
        query: {
          journal: journalid,
          user: this.userId,
          group: groupId,
        },
      });
      window.open(routeData.href, '_blank');
    },
    getDate(journal) {
      const date = new Date(journal.journal_answer.updated_at);
      return format(date, 'dd.MM.yyyy, HH:mm:ss');
    },
    getJournal() {
      const params = {
        expand: 'journal_answer,error_task_unit_count,error_comments,error_task_units',
        'search[task_id]': this.task.id,
        'search[user_id]': this.userId,
      };
      this.$rHandler(
        this.$api.journal.getJournalTasks({ params }),
        ({ data }) => {
          this.journals = data.data.reverse();
          this.loading = false;
        },
      );
    },
    showDetailWrongAnsewer(units) {
      this.$modals.show('generic-controller', {
        title: 'Неправильные ответы даны на следующие вопросы:',
        component: 'VDataTable',
        dialogProps: {
          width: 800,
        },
        'component-props': {
          items: units.map((i) => ({ title: i })),
          headers: [{ text: 'Название', value: 'title' }],
          'hide-default-footer': true,
          'hide-default-header': true,
          'items-per-page': 1000,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.journals-list {

  ::v-deep .v-list-item {

    @media screen and (max-width: 768px) {
      display: block;
    }
  }
}
</style>
